// TODO: remove when the European market opening period ends (US-5562)
import EuropeanMarket from '@/creditflowresearch/domain/Market/entities/EuropeanMarket';
import EmergingMarket from '@/creditflowresearch/domain/Market/entities/EmergingMarket';
import EmeaRegion from '@/creditflowresearch/domain/Region/entities/EmeaRegion';

export interface IMarketDealRequest {
  marketIds: string[],
  regionIds: string[],
  productIds: string[],
}

const isOnly = (ids: string[], id: string): boolean => ids.length === 1 && ids[0] === id;

const isOpenEuropeanRequest = ({ marketIds, regionIds }: IMarketDealRequest): boolean =>
  isOnly(marketIds, EuropeanMarket.MARKET_ID) && !regionIds.length;

const isOpenEmergingCeemeaRequest = ({ marketIds, regionIds, productIds }: IMarketDealRequest): boolean =>
  isOnly(marketIds, EmergingMarket.MARKET_ID)
  && !productIds.length
  && regionIds.includes(EmeaRegion.REGION_ID);

export const isOpenMarketDealRequest = (request: IMarketDealRequest): boolean =>
  isOpenEuropeanRequest(request) || isOpenEmergingCeemeaRequest(request);
